import { Component, HostListener, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from './components/map/map.component';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { RouteFormComponent } from './components/route-form/route-form.component';
import { RouteFormHeaderComponent, RouteFormFooterComponent } from '@features/planification-map/components';
import { UtilsService } from '@shared/services/utils.service';
import { RouteResultsComponent } from './components/route-results/route-results.component';
import { CoreService } from '@core/services';
import { MapService } from './components/map/services/map.service';

@Component({
  selector: 'app-planification-map',
  standalone: true,
  imports: [CommonModule, MapComponent, MatSidenavModule, RouteFormComponent, RouteFormHeaderComponent, RouteFormFooterComponent, RouteResultsComponent],
  providers: [],
  templateUrl: './planification-map.component.html',
  styleUrls: ['./planification-map.component.scss']
})
export class PlanificationMapComponent {

  @ViewChild('routeFormSidenav') sidenav!: MatSidenav;
  private utils = inject(UtilsService);
  public isMobile = this.utils.isMobile;
  private coreService = inject(CoreService);
  public sidenavOpened = this.coreService.sidenavOpened;
  public mapLoaded = inject(MapService).mapLoaded;

  public routeFormResults= this.coreService.routeFormResult;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.utils.isMobile.set(event.target.innerWidth < 768);
  }

}
